/**
 * * Скачивание файла
 * @param url Адресс изображения
 * @param filename Название файла (с расширением)
 */
export const downloadFile = async (url: string, filename: string) => {
  try {
    // Загружаем файл с помощью fetch API
    const response = await fetch(url);
    if (!response.ok) {
      throw new Error(`Ошибка загрузки файла: ${response.statusText}`);
    }

    // Преобразуем данные в Blob
    const blob = await response.blob();

    // Создаем ссылку на Blob и загружаем файл
    const link = document.createElement("a");
    const objectURL = URL.createObjectURL(blob);
    link.href = objectURL;
    link.download = filename;

    // Добавляем ссылку в DOM и кликаем по ней для скачивания
    document.body.appendChild(link);
    link.click();

    // Удаляем ссылку из DOM и освобождаем память
    document.body.removeChild(link);
    URL.revokeObjectURL(objectURL);
  } catch (error) {
    console.error("Ошибка при скачивании файла:", error);
  }
};
